export const GA_EVENT_LOGIN = 'login';
export const GA_EVENT_PAGE_VIEW = 'page_view';
export const GA_EVENT_INITIALIZE_USER = 'initialize_user';
export const GA_EVENT_CHANGE_ACCOUNT = 'change_account';
export const GA_EVENT_SEARCH_TERM = 'search_term';
export const GA_EVENT_USER_SHOPPING = 'user_shopping';
export const GA_EVENT_SIZE_CONVERSION = 'size_conversion';
export const GA_EVENT_ADD_FOOTWEAR_TO_CART = 'add_footwear_to_cart';
export const GA_EVENT_LOGIN_PAGE_VIEW = 'login_page_view';
export const GA_EVENT_SELECT_ACCOUNT_PAGE_VIEW = 'select_account_page_view';
export const GA_EVENT_WELCOME_PAGE_VIEW = 'welcome_to_gameday_page_view';
export const GA_EVENT_CONTACT_US_CLICK = 'contact_us_click';
export const GA_EVENT_CONTACT_US_PAGE_VIEW = 'contact_us_page_view';
export const GA_EVENT_SELECT_DEPARTMENT_PAGE_VIEW = 'select_department_page_view';
export const GA_EVENT_SHOP_AT_ONCE_BUTTON_CLICK = 'shop_at_once_button_click';
export const GA_EVENT_SHOP_FUTURES_BUTTON_CLICK = 'shop_futures_button_click';
export const GA_EVENT_SHOP_FORECAST_BUTTON_CLICK = 'shop_forecast_button_click';
export const GA_EVENT_GRIDWALL_ADD_TO_CART_CLICK = 'gridwall_add_to_cart_click';
export const GA_EVENT_PDP_PAGE_VIEW = 'PDP_page_view';
export const GA_EVENT_PDP_ADD_TO_CART_CLICK = 'PDP_add_to_cart_click';
export const GA_EVENT_CART_PAGE_VIEW = 'cart_page_view';
export const GA_EVENT_CART_PAYMENT_METHOD_SELECT = 'cart_payment_method_select';
export const GA_EVENT_DUPLICATE_CART_CLICK = 'duplicate_cart_click';
export const GA_EVENT_DELETE_CART_CLICK = 'delete_cart_click';
export const GA_EVENT_CHECKOUT_CLICK = 'checkout_click';
export const GA_EVENT_EDIT_CART_CLICK = 'edit_cart_click';
export const GA_EVENT_PLACE_ORDER_CLICK = 'place_order_click';
export const GA_EVENT_SUBMIT_ORDER_CLICK = 'submit_order_click';
export const GA_EVENT_ORDER_CONFIRMATION_PAGE_VIEW = 'order_confirmation_page_view';
export const GA_EVENT_ALLOTMENTS_CURRENT_PAGE_VIEW = 'allotments_current_page_view';
export const GA_EVENT_ALLOTMENTS_FUTURES_PAGE_VIEW = 'allotments_futures_page_view';
export const GA_EVENT_ALLOTMENTS_MAKE_TRANSFER_CLICK = 'allotments_make_transfer_click';
export const GA_EVENT_ALLOTMENTS_SAVE_ALLOTMENTS_CLICK = 'allotments_save_allotments_click';
export const GA_EVENT_ALLOTMENTS_ALLOW_BILLABLE_CLICK = 'allotments_allow_billable_click';
export const GA_EVENT_MANAGE_USERS_PAGE_VIEW = 'manage_users_page_view';
export const GA_EVENT_ADDRESS_BOOK_PAGE_VIEW = 'address_book_page_view';
export const GA_EVENT_OPEN_CARTS_PAGE_VIEW = 'open_carts_page_view';
export const GA_EVENT_ORDER_STATUS_PAGE_VIEW = 'order_status_page_view';
export const GA_EVENT_RETURNS_PAGE_VIEW = 'returns_page_view';
export const GA_EVENT_INVOICE_PAGE_VIEW = 'invoice_page_view';
export const GA_EVENT_INVOICE_CONTINUE_CLICK = 'invoice_continue_click';
export const GA_EVENT_TRANSACTION_REPORTS_PAGE_VIEW = 'transaction_reports_page_view';
export const GA_EVENT_TRANSACTION_REPORT_DOWNLOAD_CLICK = 'transaction_report_download_click';
export const GA_EVENT_HELP_GUIDE_CLICK = 'help_guide_click';
export const GA_EVENT_HELP_CONTACT_US_CLICK = 'help_contact_us_click';
export const GA_EVENT_ADMIN_TOOL_ICON_CLICK = 'admin_tool_icon_click';
export const GA_EVENT_PROFILE_PAGE_VIEW = 'profile_page_view';

const routeEventMap = {
  '/': GA_EVENT_WELCOME_PAGE_VIEW,
  '/login': GA_EVENT_LOGIN_PAGE_VIEW,
  '/select-accounts': GA_EVENT_SELECT_ACCOUNT_PAGE_VIEW,
  '/contact-us': GA_EVENT_CONTACT_US_PAGE_VIEW,
  '/shop/department-select': GA_EVENT_SELECT_DEPARTMENT_PAGE_VIEW,
  '/cart': GA_EVENT_CART_PAGE_VIEW,
  '/order-confirmation': GA_EVENT_ORDER_CONFIRMATION_PAGE_VIEW,
  '/account/allotments/current': GA_EVENT_ALLOTMENTS_CURRENT_PAGE_VIEW,
  '/account/allotments/future': GA_EVENT_ALLOTMENTS_FUTURES_PAGE_VIEW,
  '/account/manage': GA_EVENT_MANAGE_USERS_PAGE_VIEW,
  '/account/address-book': GA_EVENT_ADDRESS_BOOK_PAGE_VIEW,
  '/orders/open': GA_EVENT_OPEN_CARTS_PAGE_VIEW,
  '/orders/status': GA_EVENT_ORDER_STATUS_PAGE_VIEW,
  '/orders/returns': GA_EVENT_RETURNS_PAGE_VIEW,
  '/profile/info': GA_EVENT_PROFILE_PAGE_VIEW
};

/**
 *
 * @method sendEventToGA
 * @desc Send custom event data to Google Analytics
 * @param {object} eventName the event to send
 * @param {object} params the additional parameters to send with the event
 */
export const sendEventToGA = (eventName, params = {}) => {
  const finalParams = { ...params };
  if (eventName === GA_EVENT_PAGE_VIEW && !params.pageViewType) {
    const pageViewType = routeEventMap[params.pathname] || null;

    if (!pageViewType) {
      return;
    }

    finalParams.pageViewType = pageViewType;
  }

  window.dataLayer.push({ event: eventName, ...finalParams });
};
